import React from 'react';
import type { Duration } from 'date-fns';
import { PromocodeUsageStatus } from '@common/model/billing/promocode/usageStatus';
import { freemiumPromocodeParameters } from '@common/model/billing/promocode/freemium';
import { promocodeApi } from '../api';
import { useIsLoggedIn } from '../../currentUser';
import { getAccumulativeDuration } from './accumulativeDuration';

/**
 * returns total formatted duration for all activated not wasted promocodes
 */
export const useActivatedPromocodesFreePeriodDuration = (): Duration | undefined => {
  const isLoggedIn = useIsLoggedIn();
  const { data } = promocodeApi.endpoints.getPromocodesUsages.useQuery({ status: PromocodeUsageStatus.Activated }, { skip: !isLoggedIn });

  return React.useMemo(
    () =>
      !isLoggedIn
        ? getAccumulativeDuration([{ freePeriod: freemiumPromocodeParameters.freePeriod }])
        : data
          ? getAccumulativeDuration(data)
          : undefined,
    [data, isLoggedIn],
  );
};
